<div class="grid-container padding-y-4">
  <form [formGroup]="agencyTspSearchGroup" (ngSubmit)="search()">
    <fieldset class="usa-fieldset">
      <legend class="usa-legend usa-legend--large">User Administration</legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="search_type" class="usa-label">Type<abbr title="required"
                                                               class="usa-hint usa-hint--required">*</abbr></label>
          <select formControlName='searchCriteria' id="search_type" class="usa-select" (change)="onTypeChange()">
            <option hidden value='' selected disabled>Choose...</option>
            <option *ngFor="let searchForEntry of searchList" [value]="searchForEntry">{{searchForEntry}}</option>
          </select>
        </div>
      </div>
      <!-- show when Freight Carrier/Household Goods are selected -->
      <div class="grid-row grid-gap" *ngIf="frtHhgCarrier">
        <div class="grid-col-4">
          <label for="filterby_carrier" class="usa-label">Filter By<abbr title="required"
                                                                         class="usa-hint usa-hint--required">*</abbr></label>
          <select id="filterby_carrier" class="usa-select" formControlName='carrierSearchCriteria'>
            <option hidden value='' selected disabled>Choose...</option>
            <option *ngFor="let carrierEntry of carrier" [value]="carrierEntry">{{carrierEntry}}</option>
          </select>
        </div>
        <div class="grid-col-4">
          <label for="search-keyword" class="usa-label">Keyword<abbr title="required"
                                                                     class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Keyword" [attr.disabled]="keywordDisabled?'':null" id="search-keyword"
                 class="usa-input" formControlName='carrierKeyword' [typeahead]="typeaheadlist"
                 [typeaheadMinLength]="minLengthToSearch" [typeaheadOptionsLimit]="10"
                 [maxlength]="maxCharLength">
        </div>
      </div>

      <!-- show when FRT/HHG Customer is selected -->
      <div *ngIf="frtHhgAgencyCustomers" class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="search-agency-name" class="usa-label">Agency Name<abbr title="required"
                                                                             class="usa-hint usa-hint--required">*</abbr></label>
          <ng-template #agencySearchTemplate let-model="item" let-index="index">
            {{model.agencyBureauName}} - {{model.agencyCode}}
          </ng-template>
          <input id="search-agency-name" class="usa-input" formControlName='agencyName' placeholder="Search Agency"
                 [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0"
                 (typeaheadOnSelect)="typeaheadAgencyOnSelect($event)"
                 typeaheadOptionField="agencyBureauName" [typeahead]="agencyCustomerList"
                 [typeaheadItemTemplate]="agencySearchTemplate" [typeaheadScrollable]="true">
        </div>
        <div class="grid-col-4">
          <label for="search-bureau-name" class="usa-label">Bureau Name<abbr title="required"
                                                                             class="usa-hint usa-hint--required">*</abbr></label>
          <select id="search-bureau-name" class="usa-select" formControlName='bureauName'
                  [compareWith]="compareBureauNameFn">
            <option hidden value='' selected disabled>Choose...</option>
            <option *ngFor="let bureau of agencyBureauList" [value]="bureau.bureauCode">
              {{bureau.agencyBureauName}} - {{bureau.bureauCode}}
            </option>
          </select>
        </div>
      </div>

      <!--- show when User is selected -->
      <div *ngIf="userCustomer" class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="user_email" class="usa-label">Email<abbr title="required"
                                                               class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="user_email" formControlName="email" class="usa-input" [maxlength]="254">
          <div class="text-danger" *ngIf="this.agencyTspSearchGroup.get('email').hasError('email')">
            <span class="fa fa-warning"></span> Invalid Email
          </div>
        </div>
      </div>

      <div class="grid-row">
        <button type="button" class="usa-button margin-top-3" type="submit" [disabled]="!agencyTspSearchGroup.valid">
          Search
        </button>
        <ng-container *ngIf="agencyTspSearchGroup.get('searchCriteria').value === 'Freight TSP'
                  || agencyTspSearchGroup.get('searchCriteria').value === 'HouseHold Goods TSP'; else agencyBlock">
          <a routerLink="/carrierprofile" [queryParams]="">
            <button type="button" class="usa-button usa-button--base margin-top-3">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
              </svg>
              TSP
            </button>
          </a>
        </ng-container>

        <ng-template #agencyBlock>
          <ng-container *ngIf="this.showCreateAgency">
            <a routerLink="/agencyprofile" [queryParams]="{agyMasterId: agencyMasterId}">
              <button class="usa-button usa-button--base margin-top-3">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
                </svg>
                Agency
              </button>
            </a>
          </ng-container>
        </ng-template>
      </div>
    </fieldset>
  </form>

  <div class="margin-top-5" *ngIf="results">
    <!-- <span>Note: Invalid Carrier data.</span> -->
    <div *ngIf="showNoCarriers">Your search did not return any results</div>

    <!-- search results for Freight Carrier/Household Goods -->
    <table class="usa-table usa-table--borderless usa-table--striped" *ngIf="showFrtHhgCarrierTable">
      <thead>
      <tr>
        <th>SCAC</th>
        <th colspan="2">TSP Name</th>
        <th colspan="2" *ngIf=" this.businessType === 'HHG'">Domestic HHG</th>
        <th colspan="2" *ngIf=" this.businessType === 'HHG'">International HHG</th>
        <th colspan="2" *ngIf=" this.businessType === 'HHG'">Extended Storage</th>
        <th colspan="2" *ngIf=" this.businessType === 'FRT'">Domestic FRT</th>
        <th colspan="2">TSP Status</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let carrier of resultsPage">
        <td>
          <span *ngIf="(carrier.organizationId && !carrier.deletedDate); else scac">
            <a routerLink="" (click)="goToCarrierProfile(carrier)" routerLink="">{{carrier.scac}}</a>
          </span>
          <ng-template #scac>{{carrier.scac}}</ng-template>
        </td>
        <!--<td *ngIf="!(carrier.organizationId !== 0 && carrier.organizationId !== null && carrier.carrierStatus === 'Active')">{{carrier.scac}}</td>-->
        <td>{{carrier.scacName}}</td>
        <td></td>
        <td *ngIf=" this.businessType === 'HHG'">{{carrier['Domestic HHG']}}</td>
        <td *ngIf=" this.businessType === 'HHG'"></td>
        <td *ngIf=" this.businessType === 'HHG'">{{carrier['International HHG']}}</td>
        <td *ngIf=" this.businessType === 'HHG'"></td>
        <td *ngIf=" this.businessType === 'HHG'">{{carrier['Extended Storage HHG']}}</td>
        <td *ngIf=" this.businessType === 'HHG'"></td>
        <td *ngIf=" this.businessType === 'FRT'">{{carrier['Domestic FRT']}}</td>
        <td *ngIf=" this.businessType === 'FRT'"></td>
        <td>{{carrier.carrierStatus === 'Deleted' ? 'Revoked':carrier.carrierStatus}} <span *ngIf="carrier.deletedDate"> on {{carrier.deletedDate | date:'MM/dd/YYYY'}}</span></td>

        <td class="text-right" *ngIf=" this.businessType === 'FRT' && carrier.carrierStatus === 'Deleted'" >
          <button type="button" class="btn btn-warning btn-sm w-auto py-1 px-2" (click)="goToCarrierProfile(carrier)">
            Reinstate TSP
          </button>
        </td>

      </tr>
      </tbody>
    </table>

    <!-- search results for User -->
    <table class="usa-table usa-table--borderless usa-table--striped" *ngIf="showUserCustomer">
      <thead>
      <tr>
        <th>Email</th>
        <th>Last Name</th>
        <th>Organization</th>
        <th>User Permission</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let orgUser of organizationUser">
        <td>
          <span *ngIf="isValidPermissionForHyperLink(orgUser.organizationEntity, orgUser); else notHavingPermission">
            <a [routerLink]="[]" (click)="clickOnUser(orgUser)">
              {{orgUser?.userEntity?.email}}</a>
          </span>
          <ng-template #notHavingPermission>
              {{orgUser?.userEntity?.email}}
          </ng-template>
          
          </td>
        <td>{{orgUser?.userEntity?.lastName}}</td>
        <td>{{getOrganization(orgUser?.organizationEntity)}}</td>
        <td>{{getUserPermission(orgUser?.organizationEntity)}}</td>
      </tr>
      </tbody>
    </table>

    <!-- search results for Customer -->
    <div *ngIf="showFrtHhgAgencyCustomers">
      <ag-grid-angular class="ag-theme-alpine" [rowData]="agencySearchList" [domLayout]="domLayout" [pagination]="true"
                       [paginationPageSize]="itemsPerPage" [columnDefs]="agencyColumnDefs"
                       (firstDataRendered)="onFirstDataRendered($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>
